module.exports = __webpack_public_path__ + "img/caas2m-m@1.ee7a7b6e.jpg";